export const TicketTypes = {
    APP_VOUCHER: "AppVoucher",
    EVENT_TICKET: "EventTicket"
}